import type { TFunction } from "i18next";
import type { TurnGap } from "./routeChoices";

/** Each capability once: "lacks tools", "image input unknown", with an agent's estimate if any. */
export function gapsText(t: TFunction, gaps: readonly TurnGap[]): string {
  const seen = new Map(gaps.map((gap) => [gap.capability, gap] as const));
  return [...seen.values()]
    .map((gap) => {
      const text = t(`threads.hosting.fit.${gap.known}`, { capability: capabilityLabel(t, gap.capability) });
      return gap.hint === null || gap.hint === undefined ? text : `${text} (${hintText(t, gap.hint)})`;
    })
    .join(", ");
}

/** An estimate an agent reported, which DMW does not decide with (D17). */
export function hintText(t: TFunction, value: boolean | number | string): string {
  return t("threads.hosting.fit.hint", { value: typeof value === "number" ? value.toLocaleString() : String(value) });
}

/** A capability key as people read it; a key outside the shipped labels as it is. */
export function capabilityLabel(t: TFunction, capability: string): string {
  return t(`threads.hosting.capabilities.${capability}`, { defaultValue: capability });
}
